<template>
  <div id="main">
    <div class="container">
      <Homepage/>
    </div>
  </div>
</template>

<script>
  import Homepage from './components/Homepage.vue';

  export default {
    name: 'App',
    components: {
      Homepage,
    },
  };
</script>

<style lang="scss">
  @font-face {
    font-family: 'Gilroy-ExtraBold';
    src: url('./assets/fonts/Gilroy-ExtraBold.otf') format('opentype');
  }

  @font-face {
    font-family: 'Gilroy-Light';
    src: url('./assets/fonts/Gilroy-Light.otf') format('opentype');
  }

  @font-face {
    font-family: 'Lato-Black';
    src: url('./assets/fonts/Lato-Black.ttf') format('truetype');
  }

  @font-face {
    font-family: 'Poppins-SemiBold';
    src: url('./assets/fonts/Poppins-SemiBold.ttf') format('truetype');
  }

  body {
    margin: 0;
    padding: 0;
    &.menu-open {
      height: 100%;
      overflow: hidden !important;
    }
  }

  * {
    border-width: 0;
  }

  #main {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    position: relative;
    overflow: hidden;

    .container {
      /*margin: 0 auto;*/
      /*max-width: 1569px;*/
    }
  }

  ::v-deep button {
    &:focus {
      outline: none;
    }
  }
</style>
